import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmIconModule } from '../icon/index';
import { TagComponent } from './tag.component';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [TagComponent],
	imports: [CommonModule, WmIconModule, FormsModule],
	exports: [TagComponent]
})
export class WmTagModule {}
